<template>
  <section id="contact">
    <div class="py-12"></div>

    <v-container class="contact-form">
      <div class="display-3 font-weight-bold mb-3 text-center">{{ $t('contactTitle') }}</div>
      <div class="py-5"></div>
      <h2 class="mb-3 text-center" v-html="$t('contactSubtitle')"></h2>
      <v-form ref="form" @submit.prevent="sendEmail">
        <v-row dense>
          <v-col cols="12" md="6" class="p-6">
            <v-text-field name="first-name" id="first-name" flat v-bind:label="$t('contactFirstName')"></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field name="last-name" id="last-name" flat v-bind:label="$t('contactLastName')"></v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field name="reply_to" id="reply_to" flat label="Email" required :rules="emailRules"></v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field name="phone" id="phone" flat v-bind:label="$t('contactPhone')"></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-text-field name="company" id="company" flat v-bind:label="$t('contactCompany')"></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-text-field name="message" id="message" flat v-bind:label="$t('contactMessage')"></v-text-field>
          </v-col>
          <v-col cols="12" md="10">
            <v-checkbox v-bind:label="$t('contactAgree')" :rules="[v => !!v || $t('contactAgreeMust')]" required></v-checkbox>
          </v-col>
          <v-col cols="12" md="2">
            <div class="float-right">
            <v-btn type="submit" color="primary" class="white--text" x-large>Submit</v-btn>
            </div>
          </v-col>
        </v-row>
      </v-form>
    </v-container>

    <div class="py-12"></div>
  </section>
</template>

<script>
import emailjs from "emailjs-com";

export default {
  methods: {
    sendEmail(e) {
      emailjs
        .sendForm(
          "gmail",
          "template_mbs3pvo",
          e.target,
          "user_W8bTi17QryKiWJjUTXfP6"
        )
        .then(
          result => {
            console.log("SUCCESS!", result.status, result.text);
          },
          error => {
            console.log("FAILED...", error);
          }
        );
      this.$refs.form.reset();
    }
  }
};
</script>

<style scoped>
.contact-form {
  max-width: 1000px;
}
</style>